// index.tsx
// import { Link } from "react-router-dom";

// import { cn } from "@/lib/utils";

export const Footer: React.FC<React.ComponentProps<"footer">> = () =>
  //   {
  //   className,
  //   ...props
  // }
  {
    // فوتر کامنت شد تا تمام صفحه بدون اسکرول باشد
    /*
  return (
    <footer className={cn(className)} {...props}>
      <div className="flex h-[60px] items-center gap-x-3 border border-slate-300 pr-12 text-xs">
        <Link to="#" className="hover:text-primary">
          ارتباط <span className="text-[#E4EBF3]">/</span>
        </Link>
        <Link to="#" className="hover:text-primary">
          حریم‌خصوصی <span className="text-[#E4EBF3]">/</span>
        </Link>
        <Link to="#" className="hover:text-primary">
          اخبار <span className="text-[#E4EBF3]">/</span>
        </Link>
        <Link to="#" className="hover:text-primary">
          پشتیبانی <span className="text-[#E4EBF3]">/</span>
        </Link>
        <Link to="#" className="hover:text-primary">
          درباره ما <span className="text-[#E4EBF3]">/</span>
        </Link>
      </div>
      <div className="h-[30px] bg-secondary"></div>
    </footer>
  );
  */
    return null;
  };
